import { styled } from '@mui/material'

const LoginContainer = styled('form')(({ theme }) => ({
  margin: 'auto',
  width: '100%',
  minWidth: 300,
  maxWidth: 800,
  boxSizing: 'border-box',

  display: 'flex',
  rowGap: 24,
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',

  padding: theme.spacing(12, 3),

  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(12, 20),
    // 16px is the padding of the body tag
    // 240 - 2x LoginToolbar element height on desktop
    height: 'calc(100vh - 240px - 16px)',
    // 120px is the height of the LoginToolbar element on desktop
    // added bottom margin to vertically center the form
    marginBottom: '120px',
  },

  [theme.breakpoints.down('sm')]: {
    // 16px is the padding of the body tag
    // 160 - 2x LoginToolbar element height on mobile
    height: 'calc(100vh - 160px - 16px)',
    // 80px is the height of the LoginToolbar element on mobile
    // added bottom margin to vertically center the form
    marginBottom: '80px',
  },

  '& > *': {
    width: '100%',
    maxWidth: 400,
  },
}))

export default LoginContainer
